import { selectIn } from 'common/util/selector'

const summary = (state, props) => state.main.settings.organization.summary

export const overview = selectIn(summary, 'overview')
export const overviewLoading = selectIn(summary, 'overview_loading')
